var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWidgetImmigrants(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 92,
    viewBox: "0 0 192 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_503_3210)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 92,
    rx: 10,
    fill: "url(#paint0_linear_503_3210)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 29.5,
    r: 40.5,
    fill: "url(#paint1_linear_503_3210)",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.75 27.75C164.954 27.75 164.191 28.0661 163.629 28.6287C163.066 29.1913 162.75 29.9544 162.75 30.75C162.75 31.5456 163.066 32.3087 163.629 32.8713C164.191 33.4339 164.954 33.75 165.75 33.75C166.546 33.75 167.309 33.4339 167.871 32.8713C168.434 32.3087 168.75 31.5456 168.75 30.75C168.75 29.9544 168.434 29.1913 167.871 28.6287C167.309 28.0661 166.546 27.75 165.75 27.75ZM161.25 30.75C161.25 29.5565 161.724 28.4119 162.568 27.568C163.412 26.7241 164.557 26.25 165.75 26.25C166.943 26.25 168.088 26.7241 168.932 27.568C169.776 28.4119 170.25 29.5565 170.25 30.75C170.25 31.9435 169.776 33.0881 168.932 33.932C168.088 34.7759 166.943 35.25 165.75 35.25C164.557 35.25 163.412 34.7759 162.568 33.932C161.724 33.0881 161.25 31.9435 161.25 30.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.343 38.25H170.157C169.747 36.6023 168.012 35.25 165.75 35.25C163.488 35.25 161.753 36.6023 161.343 38.25ZM159.75 39C159.75 35.9963 162.549 33.75 165.75 33.75C168.951 33.75 171.75 35.9963 171.75 39C171.75 39.1989 171.671 39.3897 171.53 39.5304C171.39 39.671 171.199 39.75 171 39.75H160.5C160.301 39.75 160.11 39.671 159.97 39.5304C159.829 39.3897 159.75 39.1989 159.75 39ZM171.001 33.6555C170.912 33.8165 170.815 33.9731 170.711 34.125C171.179 34.5375 171.594 35.007 171.946 35.523C173.35 35.9993 174.357 37.0455 174.657 38.25H173.1C173.198 38.7345 173.25 39.2363 173.25 39.75H175.5C175.699 39.75 175.89 39.671 176.03 39.5304C176.171 39.3897 176.25 39.1989 176.25 39C176.25 36.906 174.889 35.1803 172.982 34.3268C173.764 33.7296 174.329 32.8925 174.59 31.9436C174.851 30.9947 174.794 29.9864 174.427 29.0731C174.06 28.1598 173.404 27.3919 172.56 26.887C171.715 26.3821 170.728 26.1681 169.75 26.2778C170.251 26.7268 170.674 27.2566 171 27.8453C171.643 28.0124 172.213 28.3883 172.62 28.914C173.026 29.4398 173.247 30.0857 173.247 30.7504C173.247 31.4151 173.026 32.061 172.62 32.5868C172.213 33.1125 171.643 33.4884 171 33.6555H171.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 70,
    r: 15,
    fill: "#AD00FF",
    fillOpacity: 0.22
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_503_3210",
    x1: 34,
    y1: -3.99999,
    x2: 192,
    y2: 111.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B138EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_503_3210",
    x1: 60,
    y1: -5.74706e-7,
    x2: 45.5,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B138EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF82E1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_503_3210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 92,
    rx: 10,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetImmigrants);
export default __webpack_public_path__ + "static/media/widget-immigrants.e6428f4e675b7ce07c369e7002c1b0a8.svg";
export { ForwardRef as ReactComponent };